// extracted by mini-css-extract-plugin
export default {"links":"style_links__LOVFB","icon":"style_icon__xCzE0","face":"style_face__83FDG","smallIcon":"style_smallIcon__1XJO6","link":"style_link__PaXj3","circle":"style_circle__I8NVT"};